// App.tsx
import '@/styles/global.css';

import React, { ReactElement } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';

import { Router } from './router';
import { StyleProvider } from './styles';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
      staleTime: 1 * 60 * 1000, // fresh while 1min
    },
  },
});

export const App = (): ReactElement => {
  return (
    <QueryClientProvider client={queryClient}>
      <StyleProvider>
        <Router />
      </StyleProvider>
      <ReactQueryDevtools initialIsOpen={false} position="bottom-left" />
    </QueryClientProvider>
  );
};
